export default __webpack_public_path__ + "images/fc5aeb818b66acb478fe17bf900b181f-1_tablet_1067x470.webp";